// extracted by mini-css-extract-plugin
export default {"column":"grid_column__Gyfqh","row":"grid_row__zGpEf","card":"grid_card__H0V3M"};